module.exports = __webpack_public_path__ + "static/media/organizationIcon.d767931a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/organizationIcon.svg
// module id = 1361
// module chunks = 0